import React from "react";

function DashboardIcon({ style }: any) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M14.25 3.75V5.25H11.25V3.75H14.25ZM6.75 3.75V8.25H3.75V3.75H6.75ZM14.25 9.75V14.25H11.25V9.75H14.25ZM6.75 12.75V14.25H3.75V12.75H6.75ZM15.75 2.25H9.75V6.75H15.75V2.25ZM8.25 2.25H2.25V9.75H8.25V2.25ZM15.75 8.25H9.75V15.75H15.75V8.25ZM8.25 11.25H2.25V15.75H8.25V11.25Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default DashboardIcon;
